/**
 * Sessiya saqlash.
 *
 * Token `localStorage` da: Electron ichida ham, brauzerda ham
 * bir xil ishlaydi. XSS xavfi bor, ammo muqobil (`httpOnly`
 * cookie) gateway va bir xil domen talab qiladi — u TBD-001
 * (production joylashuvi) hal qilinganda ko'riladi.
 */
const TOKEN_KEY = "uyda.token";
const USER_KEY = "uyda.user";
const REFRESH_KEY = "uyda.refresh";

export interface SessionUser {
  id: string;
  username: string;
  fullName: string;
  roles: string[];
  permissions: string[];
  warehouses: string[];
}

export function getToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function getUser(): SessionUser | null {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? (JSON.parse(raw) as SessionUser) : null;
  } catch {
    return null;
  }
}

export function getRefreshToken(): string | null {
  try {
    return localStorage.getItem(REFRESH_KEY);
  } catch {
    return null;
  }
}

export function saveSession(token: string, user: SessionUser, refreshToken?: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
  } catch {
    /* saqlash o'chirilgan bo'lsa sessiya faqat shu oynada yashaydi */
  }
  notify();
}

/**
 * Yangilangan token juftligi (rotatsiya): foydalanuvchi va vakolatlar
 * o'zgarmaydi — ular faqat qayta kirishda yangilanadi.
 */
export function updateTokens(token: string, refreshToken: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(REFRESH_KEY, refreshToken);
  } catch {
    /* saqlash o'chirilgan */
  }
  notify();
}

export function clearSession(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(REFRESH_KEY);
  } catch {
    /* e'tiborsiz */
  }
  notify();
}

/** Sessiya o'zgarganini kuzatish (React `useSyncExternalStore` uchun). */
const listeners = new Set<() => void>();

function notify(): void {
  for (const listener of listeners) listener();
}

export function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Joriy holat identifikatori — `useSyncExternalStore` snapshot'i. */
export function snapshot(): string {
  return getToken() ?? "";
}
